import React from 'react';
import CreationAnimation from './CreationAnimation';
import { Text } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';

const CreationAnimationLoading = (): JSX.Element => {
    return (
        <div>
            <div style={{ marginBottom: '10px', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CreationAnimation />
            </div>
            <Text variant="large" style={{ textAlign: 'center', position: 'absolute', top: '40%', left: 0, right: 0 }}>
                {IvicosStrings.processingRequestActionTitle}
            </Text>
        </div>
    );
};

export default CreationAnimationLoading;
